<template>
    <div>
        <div class="content-box mr60">
            <p>当前素材是否删除</p>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<!-- 任务管理 拒绝素材弹框-->
<script>

import API from "@/api/workOrder/material.js"
import matomoFun from "@/utils/matomo.js";
export default {
    name: "task_rejectModal",
    props: ['cbs', 'fetch', 'postItems', 'name', 'desc'],
    data(){
        return {
            formLoading:false,
            formItem:{
                group:'',
            },
            rules:{

            },
        }
    },
    mounted(){
    },
    methods:{
        pushMatomo(name) {
            // let cur_name = find(this.tags, item=>item.value == this.query.tagsActive)
            // let behaviorCategory = `素材工单(任务管理-${cur_name?.label})`
            matomoFun.trackEvent(this.name, '点击', `${this.desc}-${name}`)
        },
        submitModal(){
            // this.cbs.onSubmit()
            this.fetchDel()
        },
        hideModal(){
            this.$emit('close');
        },
        fetchDel() {
            this.pushMatomo('提交')
            this.formLoading = true
            API[this.fetch](this.postItems).then(res=>{
                this.$message.success(res.info)
                this.cbs.onSubmit()
                this.formLoading = false
            }, err=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.formLoading = false
            })
        }
    }
}
</script>

<style scoped>

</style>
